import React, { useCallback, useEffect, useState } from 'react'
import { Loader } from '@refera/ui-web'
import { useDispatch } from 'react-redux'
import { Grid, TextField, Checkbox, InputLabel, Divider } from '@mui/material'
import { postLogData } from '_modules/budget/actions'

import * as Modal from '_components/modal/generic-modal'
import useStyles from './styles'

export function AiValidationModal({
  modalInfo,
  onClose,
  problem,
  solution,
  modelSlug,
  serviceOrderId,
  budgetResolutionId,
}) {
  const styles = useStyles()
  const dispatch = useDispatch()
  const [isMandatoryInfo, setIsMandatoryInfo] = useState(false)
  const [modalErrors, setModalErrors] = useState({})
  const [iaResponse, setIaResponse] = useState('')
  const [isSelected, setIsSelected] = useState(false)
  const [reason, setReason] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  const data = {
    budgetResolutionId,
    problemId: problem?.id,
    serviceOrderId,
    serviceProviderDescription: modalInfo?.message,
    response: modalInfo?.label,
    reasonRefuse: reason,
    modelSlug,
  }

  useEffect(() => {
    if (modalInfo?.title === 'Dados necessários') {
      setIsMandatoryInfo(true)
    } else {
      setIsMandatoryInfo(false)
    }
  }, [modalInfo.title])

  const validateModalFields = useCallback(() => {
    let isValid = true
    const newErrors = {}

    if (!isSelected && !iaResponse?.trim() && isMandatoryInfo) {
      newErrors.iaResponse = 'Campo obrigatório'
      isValid = false
    }
    if (isSelected && !reason?.trim()) {
      newErrors.reason = 'Campo obrigatório'
      isValid = false
    }
    setModalErrors(newErrors)
    return isValid
  }, [isSelected, iaResponse, isMandatoryInfo, reason])

  async function handleConfirm() {
    if (!validateModalFields()) return

    const baseSolution = `${solution}\n\n${iaResponse || ''}`
    let newSolution

    if (isMandatoryInfo) {
      const payload = {
        ...data,
        serviceProviderDescription: baseSolution,
      }
      try {
        setIsLoading(true)
        const res = await dispatch(postLogData(payload))
        if (res?.description) newSolution = `${solution}\n\n${res?.description}`
      } finally {
        setIsLoading(false)
      }
    }

    const newDescription = newSolution || baseSolution

    if (modalInfo?.handleClick) modalInfo.handleClick({ description: newDescription, reason })
    onClose()
  }

  function handleCancel() {
    if (modalInfo?.handleCancel) modalInfo.handleCancel()

    onClose()
  }

  return (
    <>
      <Loader hasBackdrop open={isLoading} label="Aguarde..." />
      <Modal.Root open={modalInfo?.open} onClose={onClose}>
        <Modal.TitleModal title={modalInfo?.title} />
        <Divider />
        <Modal.Content>
          <InputLabel variant="body2" className={styles.mainLabel}>
            {modalInfo?.label}
            {!isSelected && isMandatoryInfo && <span className={styles.required}>*</span>}
          </InputLabel>

          <TextField
            name="iaResponse"
            value={iaResponse}
            fullWidth
            multiline
            variant="outlined"
            inputProps={{ maxLength: 5000 }}
            minRows={3}
            className={`${styles.input} ${modalErrors?.reason ? styles.errorMessage : ''}`}
            onChange={e => setIaResponse(e.target.value)}
            required={!isSelected && isMandatoryInfo}
            error={!!modalErrors?.iaResponse}
            helperText={modalErrors?.iaResponse}
          />

          {problem?.allowSkipMandatoryInfo && isMandatoryInfo && (
            <Grid className={styles.checkboxContainer}>
              <Checkbox
                checked={isSelected}
                onChange={() => setIsSelected(prev => !prev)}
                className={styles.checkbox}
              />
              <InputLabel variant="body2" className={[styles.label]}>
                Não quero inserir estes dados
              </InputLabel>
            </Grid>
          )}

          {isSelected && (
            <Grid className={styles.inputContainer}>
              <InputLabel variant="body2" className={styles.label}>
                Por que não quer inserir?
                {isSelected && <span className={styles.required}>*</span>}
              </InputLabel>
              <TextField
                name="reason"
                value={reason}
                fullWidth
                multiline
                variant="outlined"
                inputProps={{ maxLength: 5000 }}
                minRows={5}
                className={`${styles.input} ${modalErrors?.reason ? styles.errorMessage : ''}`}
                onChange={e => setReason(e.target.value)}
                required={isSelected}
                error={!!modalErrors?.reason}
                helperText={modalErrors?.reason}
              />
            </Grid>
          )}

          <Modal.Actions>
            <Modal.ButtonRed onClick={handleCancel}>Cancelar</Modal.ButtonRed>
            <Modal.ButtonFullBlue disabled={isLoading} onClick={handleConfirm}>
              Salvar
            </Modal.ButtonFullBlue>
          </Modal.Actions>
        </Modal.Content>
      </Modal.Root>
    </>
  )
}
